import { useDispatch } from "react-redux";
import { selectAnalytics } from "../../../../store/analytics/repository/selector";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getTimeContent } from "../../../../store/analytics/useCases/getTimeContent/action";
import dayjs, { Dayjs } from "dayjs";

export const useContentAnalytics = () => {
    const dispatch = useDispatch();
    const { timeContent } = useSelector(selectAnalytics);

    // useEffect(()=>{
    //     dispatch(getTimeContent());
    // }, []);
    
    const [dates, setDates] = useState<{ startDate: Dayjs | null, endDate: Dayjs | null }>({
        startDate: dayjs().startOf('month'),
        endDate: dayjs().endOf('month')
    });

    const handleRangeChange = (selectedDates: [start: Dayjs | null, end: Dayjs | null], dateStrings: [string, string]) => {
        if (selectedDates) {
            const [start, end] = selectedDates;
            setDates({ startDate: start, endDate: end });
        }
    };

    const disabledDate = (current: Dayjs) => {
        if (!current) {
            return false;
        }
        const { startDate, endDate } = dates;
        return false;
    };
    
    return { dates, handleRangeChange, disabledDate }
};